import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { GeneralFieldsTypeEnum } from 'app/back-office/shared/models/customer/customer.model';
import { GeneralFieldsService } from 'app/back-office/shared/services/back-office/general-fields.service';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { FilterItem, InternalFilterGroup } from 'app/shared/models/filter-group.models';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-customer-group-code-filter',
    templateUrl: './customer-group-code-filter.component.html',
    styleUrls: ['./customer-group-code-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerGroupCodeFilterComponent implements OnInit {
  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;
  loaderId = UtilityFunctions.newGuid();

  searchSettings: SearchSettings = {
      placeholder: 'Search customer group code...',
      inputId: UtilityFunctions.newGuid(),
      showFilters: false,
  };

  totalCount = 0;
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [new FilterItem({ text: 'STATUS.ALL', value: null })];

  constructor(
    private generalFieldsService: GeneralFieldsService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes.accordionState && this.accordionState && this.dataToView.length === 1) {
        this.setDataToView(0);
      }
    }

  ngOnInit(): void {
  }



  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount ? skipCount - 1 : skipCount;
      this.setDataToView(next);
    }
  }

  setDataToView(skipCount: number) { 
    const type = GeneralFieldsTypeEnum.CustomerGroupCode;
      this.generalFieldsService.getList(this.loaderId, '', type, 0, 'id desc', 0).subscribe(element => {
        
        this.dataToView = element.items.map(el => FilterMapper.CustomerGroupCodeFilter(el));
        this.totalCount = element.totalCount + 1;
        });
      }
}
